<template>
  <div style="width: 700px; position: relative">
    <div class="psychology">
      <div class="item">
        提交年份
        <el-select v-model="submitYear" class="m-2" placeholder="请选择年份" @change="selectChange">
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <!-- <div class="item">
        项目类别
        <el-select v-model="submitData.Model.EduApplyType" class="m-2" placeholder="请选择项目类别">
          <el-option v-for="item in eduChangeApplyType" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </div> -->
      <!-- <div class="item">查阅通知</div>
      <div class="item-text">
        <el-link
          v-show="isShow22022"
          href="https://hspublicfileoss.oss-cn-beijing.aliyuncs.com//Important//StudentCertificationDocuments/e95414bd-2bd6-4c11-afaf-5b929171caf9$心理学类专业教学指导委员会教改立项通知.pdf"
          type="primary"
          target="_blank"
          >关于开展 2021-2022 年度教改项目立项申报工作的通知</el-link
        >

        <el-link
          v-show="isShow"
          href="https://hspublicfileoss.oss-cn-beijing.aliyuncs.com/Important/SignUP/StudentCertificationDocuments/1fb89308-0877-4849-b164-2641888038992024-2025%E5%B9%B4%E5%BA%A6%E5%BF%83%E7%90%86%E5%AD%A6%E7%B1%BB%E4%B8%93%E4%B8%9A%E6%95%99%E5%AD%A6%E6%8C%87%E5%AF%BC%E5%A7%94%E5%91%98%E4%BC%9A%E6%95%99%E5%AD%A6%E6%94%B9%E9%9D%A9%E4%B8%8E%E7%A0%94%E7%A9%B6%E9%80%9A%E7%9F%A5%EF%BC%88%E7%AC%AC%E4%B8%80%E8%BD%AE%EF%BC%89%20(1).pdf"
          type="primary"
          target="_blank"
          >关于开展 2024-2025年度教改项目立项申报工作的通知</el-link
        >
      </div> -->

      <div class="item">第一步： 提交项目申请书（可上传多份）</div>
      <div class="item-text">
        <el-link :href="downloadFile1" type="primary">下载模板</el-link>
      </div>
      <div class="upload-media-prove upload">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :file-list="fileList" multiple
          :on-change="handleChange" :on-remove="handleRemove">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">拖到此处或 <em>点击上传</em></div>
          <template #file="{ file }">
            <a class="el-upload-a cursor el-upload-list__item-name" style="text-decoration: none"
              :href="getURL(file.fileSignPath)" target="_blank">
              <i class="el-icon-document"></i>
              {{ file.name }}
            </a>
            <label class="el-upload-list__item-status-label">
              <i class="el-icon-upload-success el-icon-circle-check"></i>
            </label>
            <i class="el-icon-close" @click="handleRemove(file)"></i>
          </template>
        </el-upload>
      </div>
      <div class="item">第二步： 提交汇总表（只可上传一份）</div>
      <div class="item-text">
        <el-link :href="downloadFile2" type="primary">下载模板</el-link>
      </div>
      <div class="upload-media-prove upload">
        <el-upload class="upload-demo" drag action="#" :auto-upload="false" :file-list="fileList2"
          :on-change="handleChange2" :limit="1" :on-remove="handleRemove2" :on-exceed="handleExceed"
          accept=".xls,.xlsx,.pdf">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">拖到此处或 <em>点击上传</em></div>
          <template #file="{ file }">
            <a class="el-upload-a cursor el-upload-list__item-name" style="text-decoration: none"
              :href="getURL(file.excelFileSignPath)" target="_blank">
              <i class="el-icon-document"></i>
              {{ file.name }}
            </a>
            <label class="el-upload-list__item-status-label">
              <i class="el-icon-upload-success el-icon-circle-check"></i>
            </label>
            <i class="el-icon-close" @click="handleRemove2(file)"></i>
          </template>
        </el-upload>
      </div>
      <div class="btn">
        <div class="btn-draft cursor" @click="draftSave" v-show="isShow">
          <span>保存为草稿</span>
        </div>
        <div class="btn-submit cursor" @click="submitSave" v-show="isShow">
          <span>提交</span>
        </div>
      </div>
    </div>
    <div class="steps" style="height: 300px" v-if="
      submitData.Model.StatusChanges != undefined &&
      submitData.Model.StatusChanges.length > 0
    ">
      <div style="margin-bottom: 20px">状态提示</div>
      <el-steps direction="vertical">
        <el-step v-for="item in submitData.Model.StatusChanges" :key="item.Id" :title="item.HindName" :status="item.StatusIdHind != 1
          ? item.StatusIdHind != 2
            ? 'error'
            : 'success'
          : 'success'
          ">
          <template #description>
            <div>
              <div>{{ item.Content }}</div>
              {{ item.CreateTime }}
            </div>
          </template>
        </el-step>
      </el-steps>
    </div>
  </div>
</template>
<script>
import { ElMessage, ElLoading, ElMessageBox } from "element-plus";
import { GetUserEducationReform, SaveEducationReform } from "../../http/psychologyTemp";
import router from "../../router/index";
import { _local } from "../../utils/storage";
import { reactive, ref } from "vue";
import { multipartUpload, signatureUrl } from "../../utils/ali-oss";
import { getURL } from "../../utils/utils";
import { eduChangeApplyType } from "../../utils/constSetting";
export default {
  setup() {
    let isShow = ref(true);
    let isShow22022 = ref(false);
    let submitYear = ref(new Date().getFullYear());

    let options = []
    for (let i = 2022; i <= new Date().getFullYear(); i++) {
      options.push({
        value: i,
        label: i
      })
    }
    let downloadFile1 = ref('')
    let downloadFile2 = ref('')
    signatureUrl('/Important//StudentCertificationDocuments/10612872-c984-49f0-abee-6f5856b6ffa6$教改项目申请书.docx').then(res => {
      downloadFile1.value = res;
    })
    signatureUrl('/Important/SignUP/admin/EducationReform/附件3： 项目汇总表.xls').then(res => {
      downloadFile2.value = res;
    })
    let matchId = JSON.parse(decodeURIComponent(router.currentRoute.value.query.MatchId));
    let forumId = JSON.parse(decodeURIComponent(router.currentRoute.value.query.ForumId));
    const user = _local.get("user");
    let data = {
      FilePath: "",
    };
    let fileList = ref([]);
    let fileList2 = ref([]);
    let list = reactive({
      Model: [],
    });
    const upload = async (file, index) => {
      let path = await multipartUpload(file);
      if (path != "" && path != null) {
        if (index == 1) {
          fileList.value.push({
            name: file.name,
            url: path,
          });
        }
        if (index == 2) {
          fileList2.value.push({
            name: file.name,
            url: path,
          });
        }
      }
    };
    const handleExceed = () => {
      ElMessage({
        message: "最多上传一份文件，请删除后重新上传",
        type: "warning",
      });
    };
    const handleChange2 = (file) => {
      if (!/\.(xls|xlsx|pdf)$/.test(file.name.toLowerCase())) {
        ElMessage.warning("上传格式不正确，请上传Excel或pdf文件");
        fileList2.value = [];
        return;
      } else {
        upload(file, 2);
      }
    };
    const handleRemove2 = (file) => {
      fileList2.value.forEach((row) => {
        if (row.url == file.url) {
          fileList2.value.splice(fileList2.value.indexOf(row), 1);
          return;
        }
      });
    };
    const handleChange = (file) => {
      upload(file, 1);
    };
    let submitData = reactive({
      Model: {
        MatchId: matchId,
        ForumId: forumId,
        UserId: user.Id,
        ProjectApplicationName: "",
        ProjectApplicationPath: "",
        SubmitYear: submitYear.value,
        Id: "",
        // EduApplyType: undefined,
        Status: 0,
        ExcelName: "",
        ExcelPath: "",
        StatusChanges: [],
      },
      Files: [],
    });
    const handleRemove = (file) => {
      fileList.value.forEach((row) => {
        if (row.url == file.url) {
          fileList.value.splice(fileList.value.indexOf(row), 1);
          return;
        }
      });
    };
    const getUserEducationReform = async () => {
      let model = {
        MatchId: matchId,
        ForumId: forumId,
        UserId: user.Id,
        submitYear: submitYear.value,
      };
      await GetUserEducationReform(model).then((res) => {
        list.Model = res.Models;
        if (res.IsSuccess) {
          if (res.Models != null && res.Models.length > 0) {
            fileList.value = [];
            if (res.Models != null && res.Models.length > 0) {
              if (
                res.Models[0].ProjectApplicationList != null &&
                res.Models[0].ProjectApplicationList.length > 0
              ) {
                res.Models[0].ProjectApplicationList.forEach((m) => {
                  fileList.value.push({
                    name: m.FileName,
                    url: m.FilePath,
                    fileSignPath: m.FileSignPath
                  });
                });
              }
              fileList2.value = [];
              if (res.Models[0].ExcelPath != null && res.Models[0].ExcelPath != "") {
                fileList2.value.push({
                  name: res.Models[0].ExcelName,
                  url: res.Models[0].ExcelPath,
                  excelFileSignPath: res.Models[0].ExcelFileSignPath,
                });
              }
              // res.Models[0].EduApplyType =
              //   res.Models[0].EduApplyType === 0 ? undefined : res.Models[0].EduApplyType;
              submitData.Model = res.Models[0];
            }
          } else {
            submitData.Model.Id = "";
            submitData.Model.Status = 0;
            submitData.Model.StatusChanges = [];
            submitData.Model.ExcelName = "";
            submitData.Model.ExcelPath = "";
            submitData.Model.SubmitYear = submitYear.value;
            // submitData.Model.EduApplyType = undefined;
            fileList.value = [];
            fileList2.value = [];
          }
        } else {
          ElMessage.error(res.ErrorMessage);
        }
      });
    };
    getUserEducationReform();

    const selectChange = () => {
      if (submitYear.value != new Date().getFullYear()) {
        isShow.value = false;
      } else {
        isShow.value = true;
      }
      if (submitYear.value == 2022) {
        isShow22022.value = true;
      } else {
        isShow22022.value = false;
      }
      console.log(submitYear.value);
      getUserEducationReform();
    };

    const submitSave = () => {
      ElMessageBox.confirm("提交之后将不可修改，确认提交吗?", "提示", {
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const loading = ElLoading.service({
          lock: true,
          text: "提交中······",
          background: "rgba(0, 0, 0, 0.7)",
        });
        if (fileList.value == null || fileList.value.length <= 0) {
          ElMessage({
            message: "请上传项目申请书",
            type: "warning",
          });
          loading.close();
          return;
        }
        if (fileList2.value == null || fileList2.value.length <= 0) {
          ElMessage({
            message: "请上传汇总表",
            type: "warning",
          });
          loading.close();
          return;
        }
        // if (!submitData.Model.EduApplyType || submitData.Model.EduApplyType === 0) {
        //   ElMessage({
        //     message: "请选择项目类别",
        //     type: "warning",
        //   });
        //   loading.close();
        //   return;
        // }
        submitData.Model.Status = 1;
        submitData.Files = [];
        fileList.value.forEach((m) => {
          submitData.Files.push({
            FilePath: m.url,
            FileName: m.name,
            TypeId: 4,
          });
        });
        submitData.Model.ExcelPath = fileList2.value[0].url;
        submitData.Model.ExcelName = fileList2.value[0].name;
        SaveEducationReform(submitData).then((res) => {
          if (res.IsSuccess) {
            submitData.Model.Id = res.Model.Id;
            ElMessage({
              message: "提交成功",
              type: "success",
            });
            getUserEducationReform();
            loading.close();
          } else {
            ElMessage.error(res.ErrorMessage);
            loading.close();
          }
        });
      });
    };
    const draftSave = () => {
      const loading = ElLoading.service({
        lock: true,
        text: "保存中······",
        background: "rgba(0, 0, 0, 0.7)",
      });
      submitData.Model.Status = 0;
      submitData.Files = [];
      if (fileList.value != null && fileList.value.length > 0) {
        fileList.value.forEach((m) => {
          submitData.Files.push({
            FilePath: m.url,
            FileName: m.name,
            TypeId: 4,
          });
        });
      }
      submitData.Model.ExcelPath = "";
      submitData.Model.ExcelName = "";
      if (fileList2.value != null && fileList2.value.length > 0) {
        submitData.Model.ExcelPath = fileList2.value[0].url;
        submitData.Model.ExcelName = fileList2.value[0].name;
      }
      SaveEducationReform(submitData).then((res) => {
        if (res.IsSuccess) {
          ElMessage({
            message: "保存成功",
            type: "success",
          });
          getUserEducationReform();
          loading.close();
        } else {
          ElMessage.error(res.ErrorMessage);
          loading.close();
        }
      });
    };

    return {
      getURL,
      handleChange,
      draftSave,
      data,
      submitSave,
      handleExceed,
      fileList,
      handleRemove,
      fileList2,
      handleChange2,
      handleRemove2,
      submitData,
      submitYear,
      options,
      selectChange,
      isShow,
      isShow22022,
      eduChangeApplyType,
      downloadFile1, downloadFile2
    };
  },
};
</script>

<style lang="scss" scoped>
.psychology {
  width: 360px;
}

.circle {
  margin-top: 20px;
}

.isShowTab {
  width: 100%;
  margin-top: 20px;
}

.circle {
  margin-top: 20px;
}

.text-tab {
  margin-left: 30px;
  border-bottom: 1px solid black;
  font-family: MicrosoftYaHei;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.85;
  letter-spacing: normal;
  text-align: left;
  color: #666;
  cursor: pointer;
}

.item {
  margin-top: 30px;
}

.item-text {
  margin-top: 20px;
}

.upload-tab {
  display: inline;
  float: right;
  width: 100px;

  >button {
    color: red;
    border: solid 1px red;
  }
}

.table {
  margin-top: 20px;
}

.upload {
  margin-top: 20px;
}

.save {
  width: 100%;
  height: 32px;
  text-align: right;
}

.tab-save {
  font-family: MicrosoftYaHei;
  font-size: 13px;
  line-height: 0.92;
  letter-spacing: 0.13px;
  text-align: center;
  color: #a31f34;
  width: 85px;
  height: 32px;
  border: solid 1px #a31f34;
  background-color: var(--h-0-s-0-l-100);
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px #a31f34;
  margin: 0 auto;
}

.download {
  width: 20%;
  text-align: right;
}

.btn {
  width: 100%;
  text-align: center;
  margin-top: 30px;
  display: flex;
  align-items: left;
  justify-content: left;
  color: rgba(255, 255, 255, 0.8);
  line-height: 44px;
  margin-bottom: 20px;
}

.btn-draft {
  min-width: 150px;
  width: 200px;
  height: 44px;
  flex-grow: 0;
  background-color: #a31f34;
  margin-right: 40px;

  >span {
    flex-grow: 0;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: 0.28px;
    text-align: center;
    color: var(--h-0-s-0-l-100);
  }
}

.btn-submit {
  float: right;
  text-align: center;
  min-width: 150px;
  width: 200px;
  height: 44px;
  flex-grow: 0;
  background-color: #a31f34;

  >span {
    flex-grow: 0;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: 0.28px;
    text-align: center;
    color: var(--h-0-s-0-l-100);
  }
}

.el-upload-a {
  text-decoration: none;
}

.steps {
  width: 300px;
  max-width: 30%;
  float: right;
  position: absolute;
  top: -50px;
  left: 420px;
}

.cursor {
  cursor: pointer;
}
</style>